// extracted by mini-css-extract-plugin
module.exports = {"typeHolder":"styles_typeHolder__1pTYP","typeHeader":"styles_typeHeader__33-Cy","radioButtons":"styles_radioButtons__3-U0s","radioButtonsGroup":"styles_radioButtonsGroup__1Lwx3"};